//============================================================================
// Name        : ls_sync_categories.ts
// Purpose     : Implement categories synchronization
// Created     : 2020-12-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import { SeTreeview } from "../controls/se_treeview";
import { IChannelData, LsSyncBase } from "./ls_sync_base";

declare const loadCategoriesUrl: string;
declare const inventoryCountCategories: string;

declare const lsSyncCategoriesPreviewUrl: string;
declare const lsSyncCategoriesUrl: string;
// declare const lsCheckAccessUrl: string;

export class LsSyncCategories extends LsSyncBase {
    treeview: SeTreeview;
    selectedIds: string[];

    constructor() {
        super("syncCategoriesDialog");
        this.filterCategories = this.filterCategories.bind(this);
        this.processSelection = this.processSelection.bind(this);
        this.syncContinue = this.syncContinue.bind(this);
        this.doCategorySync = this.doCategorySync.bind(this);

        this.treeview = new SeTreeview();
        this.treeview.setListCounter("categories", async () => {
            // Get the url from the parent
            const resp = await axios.get(`${inventoryCountCategories}.json`);
            if (resp.status != 200) {
                return window.showErrorDialog("Error getting inventory stats");
            }

            const updateCounterFunc = (cats) => {
                // Update category counts
                for (const cat of cats) {
                    const el = $(".categories-list").find(`[data-record-id='${cat.id}']`).find("div");
                    el.html(` (${cat.count})`);
                    el.parent().data("count", cat.count);

                    updateCounterFunc(cat.children);
                }
                this.treeview.countFinished("categories");
            };
            updateCounterFunc(resp.data);
        });
    }

    show(): void {
        this.treeview.loadNodes("categories", `${loadCategoriesUrl}.json`)
            .then(() => {
                this.treeview.setCheckedNodes("categories");
                $(".categories-all-list").removeClass("slideup").addClass("slidedown");
            });

        this.connectLScable(this.dialogId, (data: IChannelData) => {
            console.log(data);
            const successFinalUpdate = "Synchronization complete";
            const successV2Update    = "Synchronization Started";
            const errorFinalUpdate   = "Error pushing data to Lightspeed";
            // const successLsCredentials  = "LS credentials are fine";
            // const errorLsCredentials    = "LS credentials has some problems";

            if (data.message.toLowerCase().includes("error")) {
                this.syncCategoriesDialogDoSyncButton.prop("disabled", true);
            }

            // if (data.message == successLsCredentials || data.message == errorLsCredentials) {
            //     if (data.inProgress && data.success) {
            //         $(".checkLSAccessStatus").hide();
            //         LsSyncCategories.UpdateCheckLSAccessStatus(this.dialogId, data.message, data.inProgress, data.success);
            //         this.syncStartToContinue();
            //     } else if (!data.inProgress && !data.success) {
            //         LsSyncCategories.UpdateCheckLSAccessStatus(this.dialogId, data.message, data.inProgress, data.success);
            //         $("#syncLsCredentialsDialog").modal("show");
            //     }
            // } else
            if (data.message == successFinalUpdate || data.message == errorFinalUpdate) {
                LsSyncCategories.UpdateFinalStatus(data.message, data.inProgress, data.success);
                if (data.success) {
                    this.showRefreshBtn();
                }
            } else if (data.message == successV2Update) {
                this.syncStartedV2();
                LsSyncCategories.UpdateFinalStatus(data.message, false, true);
                this.showRefreshBtn();
            }
            else {
                if ($(".finalStatus").is(":visible")) {
                    LsSyncCategories.UpdateFinalStatus(data.message, data.inProgress, data.success);
                    if (!data.inProgress) {
                        this.disconnect();
                        if (data.success) {
                            this.showRefreshBtn();
                        }
                    }
                }
                else {
                    LsSyncCategories.UpdateCurrentStatus(this.dialogId, data.message, data.inProgress, data.success);
                }
            }
        });

        // Bind categories quick filter control
        $(".category-search").on("keyup", this.filterCategories);
        $(document).on("click", ".category-list .check-target", () => {
            setTimeout(() => this.processSelection(), 500);
        });

        // this.syncCategoriesDialogCheckLsAccessButton.off("click");
        // this.syncCategoriesDialogCheckLsAccessButton.on("click", () => { this.checkLSAccess(); });
        this.syncCategoriesDialogContinueButton.off("click");
        this.syncCategoriesDialogContinueButton.on("click", this.syncContinue);
        this.syncCategoriesDialogDoSyncButton.on("click",   this.doCategorySync);
        this.syncCategoriesDialogContinueButton.show();
        $(".sync-actions").hide();
        // $(".continue-actions").hide();
        // $(".checkLSAccessStatus").hide();
        $(".currentStatus").hide();
        $(".finalStatus").hide();
        $("#syncCategoriesDialog").modal("show");
    }

    syncStartedV2() {
        $(".finalStatus").show();
        $("#syncDialog .continueBtn").hide();
        $(".sync-actions").show();
    }

    filterCategories() {
        const filterText = $(".category-search").val() as string;
        if (filterText.trim() == "") {
            $(`.category-list li`).show();
            return;
        }

        $(`.category-list li`).not(".node-unselectable").hide();
        $(`.category-list li label`).each((_i, el) => {
            const upperVal = ($(el).text() as string).toUpperCase();
            if (upperVal.includes(filterText.toUpperCase())) {
                $(el).parent().show();
            }
        });
    }

    processSelection() {
        let qtyEnabled   = false;
        let selectedQty  = 0;
        this.selectedIds = [];
        $(".category-list input[name='categories_filter[]']:checked").each((_i, el) => {
            let qtyStr = $(el).parent().parent().find(".seTreeview-bare-label div").text().trim();
            qtyStr     = qtyStr.replace("(", "");
            qtyStr     = qtyStr.replace(")", "");

            qtyEnabled =  qtyStr == "" ? false : true;

            const qty = parseInt(qtyStr, 10);
            selectedQty += qty;

            this.selectedIds.push( $(el).val() as string );
        });

        if (qtyEnabled) {
            $(".category-total").text(` Categories Selected (${selectedQty} total items)`);
        }
        else {
            $(".category-total").text(`${this.selectedIds.length} Categories Selected`);
        }
    }

    disableCategories() {
        $(".category-search").prop("readonly", true);
        $(".category-list input[type='checkbox']").on("click", () => false);

        // Hide all categories not selected
        $(".category-list input[name='categories_filter[]']").not(":checked").parents("li").hide();
        $(".category-list input[name='categories_filter[]']:checked").parents("li").show();
    }

    async syncContinue() {
        this.disableCategories();
        this.processSelection();

        this.syncCategoriesDialogContinueButton.hide();
        $(".sync-actions").show();
        $(".currentStatus").show();

        const resp = await axios.get(lsSyncCategoriesPreviewUrl, { params: { categories: this.selectedIds } });
        if (resp.status != 200) {
            window.showErrorDialog("Generating synchronization preview.");
            return;
        }
    }

    async doCategorySync() {
        this.syncCategoriesDialogDoSyncButton.prop("disabled", true);
        $(".finalStatus").show();
        LsSyncBase.UpdateFinalStatus("Starting Synchronization...", true, false);

        const resp = await axios.get(lsSyncCategoriesUrl, { params: { categories: this.selectedIds } });
        if (resp.status != 200) {
            window.showErrorDialog(resp.data.message);
            return;
        }
    }

    // syncStartToContinue() {
    //     $(".checkLSAccessStatus").delay(5000).fadeOut("slow");
    //     $(".continue-actions").show();
    //     setTimeout(() => { this.syncCategoriesDialogContinueButton.click(); }, 100);
    // }

    // async checkLSAccess() {
    //     this.syncCategoriesDialogCheckLsAccessButton.hide();
    //     $(".checkLSAccessStatus").show();
    //
    //     const resp = await axios.get(lsCheckAccessUrl);
    //     if (resp.status != 200) {
    //         window.showErrorDialog("something went wrong, try again later.");
    //         return;
    //     }
    // }
}
